(() => {
  const ROOT_SELECTOR = '[data-thumbnail-discovery]';
  const SLIDE_SELECTOR = '.product-media__slider-thumbnails-slide';
  const MOBILE_QUERY = window.matchMedia('(max-width: 767.98px)');

  const init = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.thumbnailDiscoveryReady === 'true') return;

    const slider = root.querySelector('.product-media__slider-thumbnails');
    if (!(slider instanceof HTMLElement)) return;

    root.dataset.thumbnailDiscoveryReady = 'true';
    let swiper = null;
    let frame = 0;
    let attempts = 0;

    const slides = () => Array.from(slider.querySelectorAll(SLIDE_SELECTOR))
      .filter((slide) => !slide.classList.contains('is-hidden'));

    const desiredSlidesPerView = () => MOBILE_QUERY.matches ? 4.35 : 5.35;

    const visibleRange = (items) => {
      if (!items.length) return { first: 0, last: 0 };
      const sliderRect = slider.getBoundingClientRect();
      const overlapping = items.map((item, index) => {
        const rect = item.getBoundingClientRect();
        const overlap = Math.max(0, Math.min(rect.right, sliderRect.right) - Math.max(rect.left, sliderRect.left));
        return {
          index,
          ratio: rect.width ? overlap / rect.width : 0,
          fullyVisible: rect.left >= sliderRect.left - 1 && rect.right <= sliderRect.right + 1
        };
      });
      const first = overlapping.find((item) => item.ratio >= 0.5)?.index ?? 0;
      const fullyVisible = overlapping.filter((item) => item.fullyVisible);
      const last = fullyVisible.length ? fullyVisible[fullyVisible.length - 1].index : first;
      return { first, last };
    };

    const updateState = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const items = slides();
        const total = items.length;
        const compact = total <= Math.floor(desiredSlidesPerView());
        const range = visibleRange(items);
        const atStart = !total || range.first === 0;
        const atEnd = !total || range.last >= total - 1;

        root.classList.toggle('is-compact', compact);
        root.classList.toggle('is-at-start', atStart);
        root.classList.toggle('is-at-end', atEnd);
      });
    };

    const configureSwiper = () => {
      swiper = slider.swiper;
      if (!swiper) {
        attempts += 1;
        if (attempts < 300) window.requestAnimationFrame(configureSwiper);
        return;
      }

      const applySlidesPerView = () => {
        swiper.params.slidesPerView = desiredSlidesPerView();
        swiper.update();
        updateState();
      };

      ['init', 'update', 'resize', 'slideChange', 'transitionEnd', 'setTranslate'].forEach((eventName) => {
        swiper.on(eventName, updateState);
      });

      MOBILE_QUERY.addEventListener?.('change', applySlidesPerView);
      window.addEventListener('resize', updateState, { passive: true });

      const observer = new MutationObserver((mutations) => {
        const visibilityChanged = mutations.some((mutation) => {
          const wasHidden = mutation.oldValue?.split(/\s+/).includes('is-hidden') ?? false;
          return wasHidden !== mutation.target.classList.contains('is-hidden');
        });
        if (!visibilityChanged) return;
        swiper.update();
        updateState();
      });
      slider.querySelectorAll(SLIDE_SELECTOR).forEach((slide) => {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
      });

      applySlidesPerView();
      root.classList.add('is-ready');
    };

    configureSwiper();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
